import maplibregl from 'maplibre-gl';

class LoadingIndicatorTilesControl {
    constructor() {
        console.log("constructor of LoadingIndicatorTilesControl")
        this.container = document.createElement('div');
        this.container.className = 'maplibregl-ctrl maplibregl-ctrl-group';
        this.container.innerHTML = `
            <div id="map-loading-ind" class="spinner-border text-secondary" role="status" style="display:none;width: 21px;height: 21px;margin: 4px;">
                <span class="sr-only">Loading...</span>
            </div>
        `;

    }

    onAdd(map) {
        this.map = map;
        const ind = this.container.querySelector('#map-loading-ind');
        
        map.on('sourcedata', () => {

            if (map.areTilesLoaded()) {
                ind.style.display = "none";
            } else {
                ind.style.display = "block";
            }
        });

        return this.container;
    }

    onRemove() {
        this.container.remove();
        this.map.off('sourcedata');
        this.map = undefined;
    }
}
export {
  LoadingIndicatorTilesControl
}